module.exports = ".row-icon{width:20px;height:20px}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/access-management/groups/group-details/group-details-users-tab/group-details-users-tab.component.scss
// module id = ./src/app/access-management/groups/group-details/group-details-users-tab/group-details-users-tab.component.scss
// module chunks = access-management.module